
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum VariantListTypes {
	Normal = 0,
	Period = 1
}
export namespace VariantListTypes {
	export function getKeys(): Map<VariantListTypes, string> {
		return new Map([[0, 'Normal'], [1, 'Period']]);
	}
}
